class SwapContainer extends PIXI.Container {
  constructor(...children) {
    super();
    this.addChild(...children);
    this.hideAll();
    this.activeName = '';
  }

  hideAll() {
    this.children.forEach((child) => {
      child.visible = false;
    });
    this.activeName = '';
  }

  showOne(key) {
    this.hideAll();
    this.getChildByName(key).visible = true;
    this.activeName = key;
  }
}

export default SwapContainer;
